var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadtype1NewJewelry1Upd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type1_x5F_jewelry:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__x5F_upd_2_"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    fill: "#3A2310",
    enableBackground: "new    ",
    d: "M260.8,310.3c-0.6,0.4-0.4,1.7,0.5,1.7L260.8,310.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAB5",
    d: "M262.2,310.4c-0.8-0.8-1.8-0.3-1.4,0.6c1,2.8,1.4,6.3,1.4,10.4c0,8.4-2.4,15.3-5.4,15.3 s-3.8-1.8-3.8-10.2c0-4.4,1.5-10.1,3-13.8l-0.7-1.5c-2.8,4.3-5.1,12.4-5.1,19.2c0,10.5,2.5,14.3,7.1,14.3c4.6,0,8.3-8.5,8.3-18.9 C265.7,319.4,264.3,313.8,262.2,310.4z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M263.2,334.7c-0.8,2.7-2.5,4.7-4.5,6.4c-1.6,1.7-4.2,1.4-5.5-0.9c0.8,2.3,3.9,4,6.1,1.8 C261.8,339.9,262.5,337.3,263.2,334.7L263.2,334.7z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    fill: "#3A2310",
    enableBackground: "new    ",
    d: "M456.1,309.9c0.6,0.4,0.4,1.7-0.5,1.7L456.1,309.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAB5",
    d: "M454.7,310c0.8-0.8,1.8-0.3,1.4,0.6c-1,2.8-1.4,6.3-1.4,10.4c0,8.4,2.4,15.3,5.4,15.3s4.5-3,4.5-11.5 c0-4.4-2.3-11.2-3.4-14l0.6-2.2c2.5,3.8,5.5,13.2,5.5,19.9c0,10.5-3.1,15.7-7.7,15.7s-8.4-8.5-8.4-18.9 C451.2,319,452.6,313.4,454.7,310z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M453.7,334.2c0.8,2.7,2.5,4.7,4.5,6.4c1.6,1.7,4.2,1.4,5.5-0.9c-0.8,2.3-3.9,4-6.1,1.8 C455.1,339.5,454.4,336.9,453.7,334.2L453.7,334.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadtype1NewJewelry1Upd);
export default __webpack_public_path__ + "static/media/headtype1-new_jewelry_1_upd.f67c1f6850e25dda9c08bd1f9ae15cd2.svg";
export { ForwardRef as ReactComponent };